// src/hooks/useMutateSendAttachmentEmail.js

import { useQueryClient, useMutation } from 'react-query';

// Our Axios
import axiosInstance from 'services/API/API';

// Our Query Keys
import { ERROR_MESSAGE_DATA } from 'shared/query-keys';

// Placeholder for your imported endpoint URL constant
// NOTE: axiosInstance should handle the base URL (e.g., 'https://api-dev.sorafinance.com')
const sendAttachmentMailUrl = '/send-attachment-mail';

const useMutateSendAttachmentEmail = () => {
	const queryClient = useQueryClient();

	return useMutation(
		async (passedPayloadData) => {
			// We use the entire passedPayloadData, expecting it to be correctly
			// structured with the Base64 content already included by the component.

			const response = await axiosInstance.post(
				sendAttachmentMailUrl, // Uses the non-hardcoded URL constant
				passedPayloadData // Passes the full, prepared payload from the component
			);

			const attachmentEmailResponse = response.data.data;

			return attachmentEmailResponse;
		},
		{
			onError: (error) => {
				// Uses your existing error handling pattern
				queryClient.setQueryData(ERROR_MESSAGE_DATA, error.message);
			}
		}
	);
};

export default useMutateSendAttachmentEmail;
